import React, { Component, ErrorInfo, ReactNode } from "react";
import { mapProps } from 'recompose';
import { pick } from 'ramda';
import PropTypes from 'prop-types';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundaryBase extends Component<Props, State> {
  public state: State = {
    hasError: false
  };
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return <h1>Sorry.. there was an error</h1>;
    }

    return this.props.children;
  }
}

ErrorBoundaryBase.propTypes = {
  children: PropTypes.node.isRequired,
}

const composeComponent = mapProps(pick(['children']));


export const ErrorBoundary = composeComponent(ErrorBoundaryBase);
export default ErrorBoundary;